export default "__VITE_ASSET__Dlf_Xdaa__"